import type { NavItem } from 'components/shared/side-menu/nav-config';

export const isMenuItemActive = (
  menuItem: NavItem,
  pathname: string
): boolean => {
  if (menuItem.exactMatch) {
    return pathname === menuItem.to;
  }

  return pathname.startsWith(menuItem.match || menuItem.to);
};

export const isAnyItemActive = (
  items: NavItem[],
  pathname: string | null,
  customIsActive?: (item: NavItem) => boolean
): boolean => {
  const checkActive =
    customIsActive || ((item: NavItem) => isMenuItemActive(item, pathname!));

  return items.some((item) => {
    if (checkActive(item)) return true;

    if (item.children) {
      return item.children.some((child) => checkActive(child));
    }

    return false;
  });
};

export const filterVisibleItems = (
  items: NavItem[],
  user?: Record<string, unknown> | null,
  featureFlags?: Record<string, boolean>
): NavItem[] =>
  items.filter((item) => {
    if (typeof item.isVisible === 'function') {
      return item.isVisible(user ?? undefined, featureFlags);
    }

    return true;
  });
